import { render } from "./ButtonVolverRouter.vue?vue&type=template&id=0433326a"
import script from "./ButtonVolverRouter.vue?vue&type=script&lang=js"
export * from "./ButtonVolverRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__